var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path10, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRecordGreen(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "200px",
    height: "200px",
    viewBox: "0 0 200 200",
    enableBackground: "new 0 0 200 200",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#333333",
    d: "M99.815,196.906c-53.411,0-96.862-43.451-96.862-96.858c0-53.411,43.451-96.861,96.862-96.861 c53.408,0,96.859,43.45,96.859,96.861C196.674,153.455,153.223,196.906,99.815,196.906L99.815,196.906z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.8125,
    y1: 5.1348,
    x2: 99.8125,
    y2: 194.9604
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#B2B2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2843,
    style: {
      stopColor: "#808080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5228,
    style: {
      stopColor: "#5D5B5C"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.665,
    style: {
      stopColor: "#959394"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7767,
    style: {
      stopColor: "#2B2A2B"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#1A1A1A"
    }
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_1_)",
    d: "M99.813,194.96c-52.334,0-94.913-42.579-94.913-94.912c0-52.336,42.578-94.913,94.913-94.913 c52.333,0,94.911,42.577,94.911,94.913C194.725,152.381,152.146,194.96,99.813,194.96L99.813,194.96z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 98.334,
    y1: 94.5176,
    x2: 82.8413,
    y2: 6.6543
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#808080"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2893,
    style: {
      stopColor: "#A8A8A8"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4721,
    style: {
      stopColor: "#E3E3E3"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6599,
    style: {
      stopColor: "#BBBBBB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#E6E6E6"
    }
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_2_)",
    d: "M131.166,60.897c20.813,0,40.581,2.953,58.392,8.257c-12.844-37.215-48.221-64.02-89.744-64.02 c-52.334,0-94.913,42.577-94.913,94.913c0,3.662,0.217,7.277,0.623,10.835C29.302,81.162,76.639,60.897,131.166,60.897z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M99.813,187.162c-47.498,0-86.142-38.643-86.142-86.142c0-47.496,38.644-86.138,86.142-86.138 s86.139,38.642,86.139,86.138C185.952,148.52,147.312,187.162,99.813,187.162L99.813,187.162z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.8125,
    y1: 185.2119,
    x2: 99.8125,
    y2: 14.8799
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1218,
    style: {
      stopColor: "#B2B2B2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3503,
    style: {
      stopColor: "#7E7F80"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#010101"
    }
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_3_)",
    d: "M99.813,185.212c-46.959,0-85.167-38.205-85.167-85.164c0-46.96,38.207-85.168,85.167-85.168 c46.96,0,85.164,38.208,85.164,85.168C184.978,147.007,146.773,185.212,99.813,185.212L99.813,185.212z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 99.8564,
    y1: 103.6016,
    x2: 84.4567,
    y2: 16.2653
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F2F2F2"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1218,
    style: {
      stopColor: "#E6E6E6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3706,
    style: {
      stopColor: "#999999"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.802,
    style: {
      stopColor: "#333333"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#000000"
    }
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_4_)",
    d: "M178.239,66.846c-12.968-30.511-43.237-51.967-78.426-51.967c-46.959,0-85.167,38.208-85.167,85.168 c0,0.577,0.011,1.151,0.023,1.725c14.704,3.396,30.512,5.251,46.979,5.251C109.942,107.023,152.594,91.13,178.239,66.846z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#352612",
    d: "M99.815,177.417c-42.663,0-77.372-34.709-77.372-77.369c0-42.662,34.708-77.371,77.372-77.371 c42.659,0,77.368,34.709,77.368,77.371C177.183,142.708,142.474,177.417,99.815,177.417L99.815,177.417z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "#2E833F",
    cx: 99.813,
    cy: 100.048,
    r: 75.419
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 35.6855,
    y1: 69.2114,
    x2: 124.5742,
    y2: 69.2114
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#FFFFFF"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.002,
    style: {
      stopColor: "#FBFCFB"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.048,
    style: {
      stopColor: "#CFDAC9"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.0971,
    style: {
      stopColor: "#AEC2A6"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1517,
    style: {
      stopColor: "#91AF89"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2107,
    style: {
      stopColor: "#79A172"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2754,
    style: {
      stopColor: "#659760"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3475,
    style: {
      stopColor: "#548F51"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4306,
    style: {
      stopColor: "#458948"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5312,
    style: {
      stopColor: "#3A8542"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6677,
    style: {
      stopColor: "#328340"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#30823F"
    }
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_5_)",
    d: "M122.794,44.057c7.285,11.494-8.656,28.319-32.072,43.163 c-23.415,14.843-45.434,22.081-52.721,10.588c-7.285-11.493,2.921-37.369,26.337-52.211 C87.752,30.755,115.507,32.564,122.794,44.057z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.2222,
    y1: 139.1797,
    x2: 115.9451,
    y2: 203.5695,
    gradientTransform: "matrix(-0.8169 0.5767 -0.5767 -0.8169 302.0685 206.8574)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#F6FAF4"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.023,
    style: {
      stopColor: "#F0F7EC"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1798,
    style: {
      stopColor: "#CEE6BD"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3353,
    style: {
      stopColor: "#B1D897"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4859,
    style: {
      stopColor: "#99CD79"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6305,
    style: {
      stopColor: "#86C65F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7676,
    style: {
      stopColor: "#78C14F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8941,
    style: {
      stopColor: "#6FBE47"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6BBE45"
    }
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_6_)",
    d: "M72.583,155.52c-9.177-12.995,7.335-32.771,32.424-50.485c25.09-17.711,49.254-26.652,58.43-13.654 c9.175,12.997-0.114,43.008-25.203,60.72C113.144,169.812,81.756,168.517,72.583,155.52z"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 67.8735,
    y1: 123.5596,
    x2: 164.7549,
    y2: 123.5596
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    style: {
      stopColor: "#30823F"
    }
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    style: {
      stopColor: "#6CBF57"
    }
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "url(#SVGID_7_)",
    d: "M70.439,153.809c-9.176-12.998,7.335-32.774,32.425-50.488 c25.092-17.711,49.253-26.652,58.43-13.655c9.174,12.997-0.113,43.005-25.201,60.717 C111.002,168.098,79.614,166.806,70.439,153.809z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M139.477,56.671c-0.803,1.057-7.928-3.066-16.953-7.406c-8.996-4.394-16.72-7.445-16.391-8.729 c0.29-1.243,8.955-0.138,18.446,4.487C134.093,49.607,140.269,55.673,139.477,56.671z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFFFFF",
    d: "M153.843,69.215c-0.776,0.724-3.546-0.979-6.384-3.569c-2.834-2.598-4.757-5.188-4.105-6.025 c0.646-0.833,3.729,0.487,6.689,3.199C153.008,65.524,154.614,68.497,153.843,69.215z"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRecordGreen);
export default __webpack_public_path__ + "static/media/recordGreen.d0f71e0d169075f6c0c44f51a43d3013.svg";
export { ForwardRef as ReactComponent };